
document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      mobileNav.hidden = isOpen;
      document.body.classList.toggle('menu-open', !isOpen);
    });
  }

  document.addEventListener('click', (event) => {
    const dialog = document.querySelector('[data-size-guide]');
    if (!dialog) return;

    if (event.target.closest('[data-size-guide-open]')) {
      if (typeof dialog.showModal === 'function') dialog.showModal();
    }
    if (event.target.closest('[data-size-guide-close]')) {
      dialog.close();
    }
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) dialog.close();
    }
  });

  document.querySelectorAll('.qty-box').forEach((box) => {
    const input = box.querySelector('[data-qty-input]');
    const minus = box.querySelector('[data-qty-minus]');
    const plus = box.querySelector('[data-qty-plus]');
    if (!input || !minus || !plus) return;

    minus.addEventListener('click', () => {
      const current = parseInt(input.value || '1', 10);
      input.value = Math.max(1, current - 1);
    });
    plus.addEventListener('click', () => {
      const current = parseInt(input.value || '1', 10);
      input.value = current + 1;
    });
  });

  document.querySelectorAll('[data-product-picker]').forEach((picker) => {
    const dataEl = picker.querySelector('[data-product-variants]');
    const hiddenSelect = picker.querySelector('[data-variant-select]');
    const hiddenIdInput = picker.closest('form')?.querySelector('[data-variant-id]');
    if (!dataEl || !hiddenSelect || !hiddenIdInput) return;

    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

    function selectedOptions() {
      return Array.from(picker.querySelectorAll('.variant-group')).map((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant() {
      const selections = selectedOptions();
      return variants.find((variant) => selections.every((val, index) => !val || variant.options[index] === val));
    }

    function syncVisuals() {
      picker.querySelectorAll('.variant-group').forEach((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        const selectedValue = group.querySelector('[data-selected-value]');
        if (selectedValue && checked) selectedValue.textContent = checked.value;
        group.querySelectorAll('.variant-chip').forEach((chip) => {
          const radio = chip.querySelector('input[type="radio"]');
          chip.classList.toggle('is-selected', !!radio.checked);
        });
      });
    }

    function syncVariant() {
      const match = findVariant();
      if (match) {
        hiddenSelect.value = match.id;
        hiddenIdInput.value = match.id;
      }
      syncVisuals();
    }

    picker.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', syncVariant);
    });

    syncVariant();
  });
});
